import React, {useState} from "react";
import {GenericModal} from "../generic-modal/GenericModal";
import {Box, Button} from "@mui/material";
import {JobSettingsEditor} from "./JobSettingsEditor";
import {Processor} from "../../models/JobDefinitionStep";

interface IGraphQlEditorButtonProps {
	settings: string;
	setSettings: (query: string) => void;
	processor: Processor;
}

export const JobSettingsEditorButton: React.FC<IGraphQlEditorButtonProps> = (props) => {
	const [editSettings, setEditSettings] = useState(false);
	
	return (
		<>
			<Box sx={{marginTop: 1, marginBottom: 1}}>
				<Button
					variant="outlined"
					onClick={() => setEditSettings(true)}
				>
					Edit Settings
				</Button>
			</Box>
			<GenericModal
				open={editSettings}
				onClose={() => setEditSettings(false)}
				title={"Settings Query"}
			>
				<JobSettingsEditor {...props} />
			</GenericModal>
		</>
	);
};
